import React from "react";
import INFO from "../../data/user";

const CTASection = () => {
  return (
    <section className="relative bg-lab-ink text-lab-paper border-t border-lab-rule">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-2 font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim">
            <div>§ 05</div>
            <div className="text-lab-paper mt-1">Next</div>
          </div>

          <div className="col-span-12 md:col-span-7">
            <h2 className="font-display text-4xl md:text-6xl font-semibold tracking-tightest text-lab-paper leading-[0.95]">
              The lab is closed.
              <br />
              <span className="text-lab-paper-dim">The work continues elsewhere.</span>
            </h2>

            <a
              href={INFO.socials.website.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-4 mt-10 border border-lab-rule-strong hover:border-lab-accent px-5 py-3 font-mono text-[12px] tracking-widest uppercase text-lab-paper hover:text-lab-accent transition-colors"
            >
              <span>chloelavrat.com</span>
              <span className="w-8 h-px bg-lab-paper-dim group-hover:bg-lab-accent transition-colors" />
              <svg className="w-3 h-3" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M3 9L9 3M9 3H4M9 3V8" strokeLinecap="square" />
              </svg>
            </a>
          </div>

          <div className="col-span-12 md:col-span-3 font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim space-y-4">
            <a
              href={INFO.socials.github.link}
              target="_blank"
              rel="noopener noreferrer"
              className="border-t border-lab-rule pt-4 flex justify-between hover:text-lab-paper transition-colors"
            >
              <span>GitHub</span>
              <span className="text-lab-paper">chloelavrat</span>
            </a>
            <a
              href={INFO.socials.linkedin.link}
              target="_blank"
              rel="noopener noreferrer"
              className="border-t border-lab-rule pt-4 flex justify-between hover:text-lab-paper transition-colors"
            >
              <span>LinkedIn</span>
              <span className="text-lab-paper">clavrat</span>
            </a>
            <a
              href={INFO.socials.website.link}
              target="_blank"
              rel="noopener noreferrer"
              className="border-t border-lab-rule pt-4 flex justify-between hover:text-lab-paper transition-colors"
            >
              <span>Folio</span>
              <span className="text-lab-paper">chloelavrat.com</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
